import { ThemeProvider, createTheme } from "@mui/material";
import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "suneditor/dist/css/suneditor.min.css";
import App from "./App";
import { store, persistor } from "./Store/store";
import SuspenseContent from "./containers/SuspenseContent";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = () =>
  createTheme({
    palette: {
      secondary: {
        main: "#F86F03",
        light: "#F5EBFF",
        contrastText: "#47008F",
      },
    },
    components: {
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            backgroundColor: "#87004C",
          },
        },
      },

      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            fontFamliy: "inter",
          },
        },
      },
    },
  });

root.render(
  // <React.StrictMode>
  <Suspense fallback={<SuspenseContent />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </Suspense>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
